import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export type UiButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'danger' | 'ghost';
export type UiButtonType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'app-ui-button',
  template: `
    <button
      class="ui-button"
      [class.ui-button--primary]="variant() === 'primary'"
      [class.ui-button--secondary]="variant() === 'secondary'"
      [class.ui-button--tertiary]="variant() === 'tertiary'"
      [class.ui-button--danger]="variant() === 'danger'"
      [class.ui-button--ghost]="variant() === 'ghost'"
      [class.ui-button--full]="fullWidth()"
      [disabled]="disabled()"
      [attr.aria-label]="ariaLabel()"
      [type]="type()"
      (click)="handleClick()"
    >
      <ng-content />
    </button>
  `,
  styleUrl: './ui-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiButtonAtomComponent {
  readonly variant = input<UiButtonVariant>('primary');
  readonly disabled = input(false);
  readonly ariaLabel = input<string | null>(null);
  // 'submit' permite usar el átomo dentro de un <form> respetando (ngSubmit) y Enter-to-submit.
  readonly type = input<UiButtonType>('button');
  readonly fullWidth = input(false);

  readonly pressed = output<void>();

  handleClick(): void {
    if (!this.disabled()) {
      this.pressed.emit();
    }
  }
}
